import type { IconSvgObject } from './types';

const Jpg02Icon: IconSvgObject = [
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 15V14H17.5V19H21V17H20M10.5 14V17.25C10.5 18.2165 9.7165 19 8.75 19H8.66667C7.74619 19 7 18.2538 7 17.3333M12.5 19V17M12.5 17V14H14C14.8284 14 15.5 14.6716 15.5 15.5C15.5 16.3284 14.8284 17 14 17H12.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Jpg02Icon;
